import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Input,
  Spacer,
  useDisclosure,
  VStack,
  Image,
  Text,
  Select,
} from "@chakra-ui/react";
import { REQUEST_MASTER_RESTAURANT } from "../../store/restaurant/restaurantActionTypes";
import RestaurantTable from "../../components/RestaurantTable/RestaurantTable";
import RestaurantEditDrawer from "../../components/drawer/RestaurantEditDrawer";
import { REQUEST_MASTER_SLOTS } from "../../store/slots/slotsActionTypes";

const Restaurantmanagement = () => {
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchQuery, setSearch] = useState("");
  useEffect(() => {
    // if (!busy && !(masterCategory || []).length) {
    dispatch({ type: REQUEST_MASTER_RESTAURANT });
    dispatch({ type: REQUEST_MASTER_SLOTS });
    console.log("dispatched");

    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <VStack top={5} position="relative" key={"vStack"}>
        <Flex w="92%" alignItems="center" justifyContent="space-between">
          <Heading ml="8" size="md" fontWeight="semibold" color="black.400">
            Restaurant management
          </Heading>
          <Spacer></Spacer>
          <Heading size="sm" fontWeight="semibold">
            <Flex alignItems="center" gap={2}>
              <Image
                borderRadius="full"
                boxSize="50px"
                src="https://bit.ly/dan-abramov"
                alt="Dan Abramov"
              />
              <Text>Admin</Text>
            </Flex>
          </Heading>
        </Flex>
      </VStack>
      <RestaurantTable query={searchQuery} />
      {isOpen && <RestaurantEditDrawer isOpen onClose={onClose} />}
    </>
  );
};

export default Restaurantmanagement;
